import { NoddiAsyncError } from 'noddi-types';
import { getInternalErrorMessage } from 'noddi-util';
import { type ExternalToast, toast } from 'sonner';

const error = (input: string | NoddiAsyncError, options?: ExternalToast) => {
  if (typeof input === 'string') {
    return toast.error(input, options);
  } else {
    const errorDescription = getInternalErrorMessage(input);
    return toast.error(errorDescription, options);
  }
};

export const noddiToast = {
  ...toast,
  error
};
